<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */

/**
 * Horizontal-layout
 */
import Swal from "sweetalert2";
import ListProduct from "./list-product";
import PopupVoucher from "./popup-voucher";
import PopupDiscount from "./popup-dicount";
import PopupCustomer from "./popup-customer";
import PopupPayment from "./popup-payment";
import PopupCashier from "./popup-cashier";
import PopupEbill from "./popup-ebill";
import PrintCart from "./print-cart";
import PopupSelectDiscount from "./popup-select-discount";
import PopupTransportFee from "./popup-transport-fee";

import { urlMethods } from "@/state/helpers";

export default {
  data() {
    return {
      sessionList: [],
      showPrint: true,
      loadingArr: {
        main: true,
      },
    };
  },
  components: {
    ListProduct,
    PopupVoucher,
    PopupDiscount,
    PopupCustomer,
    PopupPayment,
    PopupCashier,
    PopupSelectDiscount,
    PrintCart,
    PopupTransportFee,
    PopupEbill,
  },
  computed: {
    orderNote: {
      get: function() {
        return this.$store.getters["sale/orderNote"];
      },
      set: function(value) {
        this.$store.dispatch("sale/setOrderNote", value);
      },
    },
    currentUser: function() {
      return this.$store.getters["auth/currentUser"];
    },
    noti: function() {
      let arr = this.$store.getters["sale/noti"];
      if (typeof arr == "undefined" || !arr || arr.length < 1) return [];
      return JSON.parse(JSON.stringify(arr)).reverse();
    },
    tabs: function() {
      return this.$store.getters["sale/tabs"];
    },
    currentTab: function() {
      return this.$store.getters["sale/currentTab"];
    },
    nvbh: function() {
      let currentTab = this.$store.getters["sale/currentTab"];
      return typeof currentTab.info != "undefined" &&
        typeof currentTab.info.nvbh != "undefined" &&
        typeof currentTab.info.nvbh.name != "undefined"
        ? currentTab.info.nvbh.name
        : "";
    },
    totalPayment: function() {
      return this.$store.getters["sale/totalPayment"];
    },
    totalEbill: function() {
      return this.$store.getters["sale/totalEbill"];
    },
    returnAmount: function() {
      var returnAmount = this.currentTab.info.returnAmount + this.totalEbill;
      if (returnAmount < 0) returnAmount = 0;
      return returnAmount;
    },
    sessionID: function() {
      return this.$store.getters["sale/sessionID"];
    },
    posID: function() {
      let posID = this.$store.getters["sale/posID"];
      return typeof posID != "undefined" && typeof posID.pos_id != "undefined"
        ? posID.pos_id
        : 0;
    },
    posInfo: function() {
      let posID = this.$store.getters["sale/posID"];
      return typeof posID != "undefined" && typeof posID.id != "undefined"
        ? posID
        : false;
    },
    posName: function() {
      let posID = this.$store.getters["sale/posID"];
      return typeof posID != "undefined" && typeof posID.pos_name != "undefined"
        ? posID.pos_name
        : "TGA POS";
    },
    customer: function() {
      let customer = this.$store.getters["sale/customer"];
      return typeof customer != "undefined" && typeof customer.id != "undefined"
        ? customer
        : false;
    },
    customerName: function() {
      let customer = this.$store.getters["sale/customer"];
      return typeof customer != "undefined" &&
        typeof customer.name != "undefined"
        ? customer.name
        : "";
    },
    voucher: function() {
      return this.$store.getters["sale/voucher"];
    },
    district: function() {
      return this.$store.getters["sale/sesdistrictsionID"];
    },
    province: function() {
      return this.$store.getters["sale/province"];
    },
    cashier: function() {
      return this.$store.getters["sale/cashier"];
    },
    paymentMethod: function() {
      return this.$store.getters["sale/paymentMethod"];
    },
  },
  created: () => {
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    ...urlMethods,
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    isLoading: function(name = "") {
      return typeof this.loadingArr[name] == "undefined"
        ? false
        : this.loadingArr[name];
    },
    setLoading(name = "", value = false) {
      this.loadingArr[name] = value;
    },
    addNewTab() {
      this.$store.dispatch("sale/addNewTab");
      setTimeout(() => {
        this.$refs.listProduct.$refs.serial.focus();
      }, 100);
    },
    activeTab(id) {
      this.$store.dispatch("sale/activeTab", id);
      setTimeout(() => {
        this.$refs.listProduct.$refs.serial.focus();
      }, 100);
    },
    removeDiscountMember() {
      Swal.fire({
        title: "Bạn có chắc chắn?",
        showCancelButton: true,
        confirmButtonText: "Có. Xoá ngay",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("sale/removeDiscountCustomer");
        }
      });
    },
    setSession(_data) {
      this.$store.dispatch("sale/setSession", _data.id);
      this.$store.dispatch("sale/setPosID", _data);
      let session_start = this.posInfo.start_at.split(" ")[0];
      if (session_start < this.moment().format("YYYY-MM-DD")) {
        this.$store.dispatch("sale/setSession", 0);
        this.$store.dispatch("sale/setPosID", false);
        this.$store.dispatch("sale/removeAllTab", false);
        throw "Không có phiên bán hàng khả dụng";
      }
      this.getCashier();
      this.getPayment();
    },
    async getCashier() {
      try {
        let res = await this.postUrl({
          url: "cashier",
          data: { pid: this.posID },
        });
        if (typeof res.data != "undefined" && res.data) {
          this.$store.dispatch("sale/setCashier", res.data);
        }
      } catch (error) {
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
    },
    async getPayment() {
      try {
        let res = await this.postUrl({
          url: "payments",
          data: { sid: this.sessionID },
        });
        if (typeof res.data != "undefined" && res.data) {
          this.$store.dispatch("sale/setPaymentMethodList", res.data);
        }
      } catch (error) {
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
    },
    async validateSession() {
      let that = this;
      try {
        let res = await this.postUrl({
          url: "session/validate",
          data: { sid: this.sessionID },
        });
        if (
          typeof res == "undefined" ||
          typeof res.data == "undefined" ||
          typeof res.error == "undefined" ||
          typeof res.message == "undefined"
        ) {
          throw "Không thế kết nối server";
        }
        if (res.error) {
          throw res.message;
        }
        if (!res.data) {
          throw "Lỗi! Không thể xác minh phiên bán hàng";
        }
        that.setLoading("main", false);
        that.getPayment();
        that.getCashier();
        that.$store.dispatch("sale/createNewData");
        that.$store.dispatch("sale/recalcData");
      } catch (error) {
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        this.$store.dispatch("sale/setSession", 0);
        this.$store.dispatch("sale/setPosID", false);
        this.$store.dispatch("sale/removeAllTab", false);
        that.setLoading("main", false);
      }
    },
    async getPosData() {
      let that = this;
      try {
        let res = await this.getUrl("pos-info");
        this.sessionList = res.data.sessionList;
        if (!this.sessionList || this.sessionList.length < 1) {
          throw "Không có phiên bán hàng khả dụng";
        }
        if (this.sessionList.length == 1) {
          this.$store.dispatch("sale/setSession", this.sessionList[0].id);
          this.$store.dispatch("sale/setPosID", this.sessionList[0]);
          this.getCashier();
          this.getPayment();
          this.setLoading("main", false);
        }
        let session_start = this.posInfo.start_at.split(" ")[0];
        if (session_start < this.moment().format("YYYY-MM-DD")) {
          this.$store.dispatch("sale/setSession", 0);
          this.$store.dispatch("sale/setPosID", false);
          this.$store.dispatch("sale/removeAllTab", false);
          throw "Không có phiên bán hàng khả dụng";
        }
        this.$store.dispatch("sale/setDistrictProvince", {
          district: res.data.district,
          province: res.data.province,
        });
        that.setLoading("main", false);
        that.getPayment();
        that.getCashier();
        that.$store.dispatch("sale/createNewData");
        that.$store.dispatch("sale/recalcData");
        setTimeout(() => {
          this.setLoading("main", false);
        }, 100);
      } catch (error) {
        setTimeout(() => {
          this.setLoading("main", false);
        }, 100);
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        this.$store.dispatch("sale/setSession", 0);
        this.$store.dispatch("sale/setPosID", false);
        this.$store.dispatch("sale/removeAllTab", false);
      }
    },
    removeTab(id) {
      Swal.fire({
        title: "Bạn có chắc chắn xoá Hoá đơn này?",
        showCancelButton: true,
        confirmButtonText: "Có. Xoá ngay",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("sale/removeTab", id);
          setTimeout(() => {
            this.$refs.listProduct.$refs.serial.focus();
          }, 100);
        }
      });
    },
    showPopupVoucher() {
      this.$bvModal.show("modal-voucher");
    },
    showPopupTransportFee() {
      this.$bvModal.show("modal-transport-fee");
    },
    showPopupDiscount() {
      this.$bvModal.show("modal-discount-other");
    },
    showPopupPayment() {
      this.$bvModal.show("modal-payment");
    },
    showPopupEbill() {
      this.$bvModal.show("modal-ebill");
    },
    showPopupCustomer() {
      this.$bvModal.show("modal-customer");
    },
    showPopupCashier() {
      this.$bvModal.show("modal-cashier");
    },
    checkSelectDiscount() {
      let that = this;
      setTimeout(() => {
        if (
          typeof that.voucher != "undefined" &&
          typeof that.voucher.with_vip != "undefined" &&
          !that.voucher.with_vip &&
          this.currentTab.info.customerDiscount > 0
        ) {
          that.$bvModal.show("modal-select-discount");
        }
      }, 100);
    },
    async createOrder() {
      let that = this;
      try {
        if (this.currentTab.products.length < 1) {
          throw "Chưa có sản phẩm";
        }
        if(this.currentTab.info.totalAmount != this.currentTab.info.totalAmountGross || this.currentTab.info.totalAmount < 0){
          throw "Tổng đơn hàng đang nhỏ hơn 0";
        }
        if (!this.customer) {
          that.showPopupCustomer();
          throw "Chưa chọn khách hàng";
        }
        if (!this.nvbh || this.nvbh == "") {
          that.showPopupCashier();
          throw "Chưa chọn nhân viên bán hàng";
        }
        if (
          this.totalPayment + this.totalEbill < this.currentTab.info.totalAmount
        ) {
          that.showPopupPayment();
          throw "Số tiên thanh toán chưa đủ";
        }
        that.$store.dispatch("sale/setTabLoading", true);
        setTimeout(() => {
          that.createOrderStep2();
        }, 100);
      } catch (error) {
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
    },
    async reloadVoucher(){
      let that = this;
      if(!(typeof this.currentTab.info.voucher != 'undefined' && typeof this.currentTab.info.voucher.name != 'undefined' && this.currentTab.info.voucher.name != null && this.currentTab.info.voucher.name != '')) return false;
      try {
        let res = await that.postUrl({url: "search-voucher", data: { code: this.currentTab.info.voucher.name },});
        if ( typeof res == "undefined" || typeof res.data == "undefined" || typeof res.error == "undefined" || typeof res.message == "undefined" ) {
          throw "Không thế kết nối server";
        }
        if (res.error) {
          throw res.message;
        }
        if (!res.data) {
          throw "Voucher không khả dụng";
        }
        let voucher = res.data;
        var total_amount = that.currentTab.info.totalAmount;
        if (total_amount < voucher.min_order) {
          throw "Voucher chỉ áp dụng cho đơn hàng có Tổng tiền hàng tối thiểu " + parseFloat(voucher.min_order).toLocaleString() + "đ";
        }
        that.$store.dispatch("sale/setVoucher", voucher);
      } catch (error) {
        console.log(error);
        that.$store.dispatch("sale/removeVoucher");
      }
      that.$store.dispatch("sale/recalcData");
    },
    async createOrderStep2() {
      let that = this;
      try {
        let payments = [];
        for (const pat of that.currentTab.info.payment) {
          var amountItem = parseFloat(pat.value);
          if (amountItem > 0) {
            payments.push({
              statement_id: pat.statement_id,
              journal_id: pat.journal_id,
              journal_name: pat.journal_name,
              amount: amountItem,
            });
          }
        }
        let productsArr = {};
        let serials = [];
        let products = [];
        for (const p of that.currentTab.products) {
          for (var s of p.serials) {
            serials.push(s);
            products.push({
              qty: p.amount,
              discount: p.discount * 1,
              price_unit: p.cost,
              product_id: p.id,
              serials: s,
            });
            productsArr[s] = {
              qty: p.amount,
              name: p.name,
              discount: p.discount * 1,
              price_unit: p.cost,
              product_id: p.id,
              serials: s,
            };
          }
        }
        var data = {
          amount_paid: that.totalPayment + that.totalEbill,
          amount_total: that.currentTab.info.totalAmount,
          amount_return: that.returnAmount,
          serials: serials,
          products: products,
          products_arr: productsArr,
          account_statements: payments,
          partner_id: that.currentTab.info.customer.id,
          note:
            that.orderNote +
            (that.currentTab.info.otherDiscountNote != ""
              ? ` ${that.currentTab.info.otherDiscountNote}`
              : ""),
          other_discount: that.currentTab.info.otherDiscount,
          transport_fee: that.currentTab.info.transportFee,
          voucher_discount: that.currentTab.info.voucherDiscount,
          member_discount: that.currentTab.info.customerDiscountValue,
          voucher_id: Object.keys(that.currentTab.info.voucher).length
            ? that.currentTab.info.voucher.id
            : 0,
          voucher_name: Object.keys(that.currentTab.info.voucher).length
            ? that.currentTab.info.name
            : "",
          sale_man: that.currentTab.info.nvbh.id,
          sale_man_name: that.currentTab.info.nvbh.name,
          pos_id: that.posID,
          pos_name: that.posName,
          session_id: that.sessionID,
          ebill: that.currentTab.ebill,
          totalEbill: that.totalEbill,
        };
        var newNote = [];
        if (that.currentTab.ebill.length > 0) {
          for (const ebillNote of that.currentTab.ebill) {
            newNote.push(ebillNote.name);
          }
          if (newNote.length > 0) {
            if (data.note.length > 0) {
              data.note += `. eBill: ` + newNote.join(", ");
            } else {
              data.note += `eBill: ` + newNote.join(", ");
            }
          }
        }
        console.log(data);
        //console.log(data.amount_return);
        //throw "log data " + data.amount_return;
        let res = await that.postUrl({ url: "create-order", data: data });
        if (
          typeof res == "undefined" ||
          typeof res.data == "undefined" ||
          typeof res.error == "undefined" ||
          typeof res.message == "undefined"
        ) {
          throw "Không thế kết nối server";
        }
        if (res.error) {
          throw res.message;
        }
        if (!res.data) {
          throw "Lỗi! Không thể tạo đơn hàng";
        }
        that.$store.dispatch("sale/setTabPrint", true);
      } catch (error) {
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
      this.$store.dispatch("sale/setTabLoading", false);
    },
  },
  async mounted() {
    let that = this;
    this.setLoading("main", true);
    for (const item of this.tabs) {
      this.loadingArr["tab_" + item.id] = false;
    }
    this.$store.dispatch("sale/setTabPrint", false);
    this.$store.dispatch("sale/setTabLoading", false);
    if (this.sessionID > 1) {
      let session_start = this.posInfo.start_at.split(" ")[0];
      if (session_start < this.moment().format("YYYY-MM-DD")) {
        this.$store.dispatch("sale/setSession", 0);
        this.$store.dispatch("sale/setPosID", false);
        this.$store.dispatch("sale/removeAllTab", false);
      }
      await this.validateSession();
    } else {
      await that.getPosData();
    }
    await that.reloadVoucher();
    


    this.$mousetrap.bind("f4", function(e) {
      e.preventDefault();
      that.showPopupVoucher();
      return false;
    });
    this.$mousetrap.bind("f6", function(e) {
      e.preventDefault();
      that.showPopupDiscount();
      return false;
    });
    this.$mousetrap.bind("f7", function(e) {
      e.preventDefault();
      that.showPopupPayment();
      return false;
    });
    this.$mousetrap.bind("f8", function(e) {
      e.preventDefault();
      that.showPopupCustomer();
      return false;
    });
    this.$mousetrap.bind("f9", function(e) {
      e.preventDefault();
      that.showPopupCashier();
      return false;
    });
    this.$mousetrap.bind("f10", function(e) {
      e.preventDefault();
      that.createOrder();
      return false;
    });
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      that.checkSelectDiscount();
    });
    this.checkSelectDiscount();
  },
};
</script>

<template>
  <div style="min-width: 999px">
    <div
      v-for="tab in tabs"
      :key="tab.id"
      :class="
        tab.loading && currentTab.id == tab.id ? 'flex-middle-full' : 'hidden'
      "
    >
      <i class="fas fa-spinner fa-spin font-size-34"></i>
    </div>
    <header id="page-topbar" style="min-width: 999px">
      <div class="navbar-header" style="max-width: unset;">
        <div class="d-flex">
          <div class="navbar-brand-box">
            <div style="color: white;line-height: 50px;font-weight: bold;">
              {{ posName || "TGA POS" }}
            </div>
          </div>
          <ul class="sale-tabs">
            <li
              v-for="tab in tabs"
              :key="tab.id"
              :class="tab.id == currentTab.id ? 'active' : ''"
            >
              <span @click="activeTab(tab.id)">Hoá đơn {{ tab.id }}</span>
              <i
                v-if="
                  typeof currentTab.id != 'undefined' &&
                    tab.id == currentTab.id &&
                    tabs.length > 1
                "
                @click="removeTab(tab.id)"
                class="bx bx-x-circle font-size-22 align-middle me-1"
              ></i>
            </li>
            <li class="plus-tabs" @click="addNewTab" v-if="tabs.length < 5">
              <i class="bx bx-plus font-size-22 align-middle me-1"></i>
            </li>
          </ul>
        </div>

        <div class="d-flex">
          <b-dropdown right variant="black" toggle-class="header-item">
            <template v-slot:button-content>
              <img
                class="rounded-circle header-profile-user"
                src="@/assets/images/users/avatar-1.png"
                alt="Header Avatar"
              />
              <span class="d-xl-inline-block ms-1">{{ currentUser.name }}</span>
              <i class="mdi mdi-chevron-down d-xl-inline-block"></i>
            </template>
            <b-dropdown-divider></b-dropdown-divider>
            <a href="/sale" class="dropdown-item"
              ><i class="bx bx-basket font-size-16 align-middle me-1"></i> Mở
              POS bán hàng
            </a>
            <router-link to="/session" class="dropdown-item"
              ><i class="bx bx-calendar font-size-16 align-middle me-1"></i>
              Phiên bán hàng
            </router-link>
            <router-link to="/" class="dropdown-item"
              ><i class="bx bx-grid-alt font-size-16 align-middle me-1"></i>
              Danh sách đơn hàng
            </router-link>
            <router-link to="/hbcod" class="dropdown-item"
              ><i class="bx bx-grid-alt font-size-16 align-middle me-1"></i>
              Thu hồi COD
            </router-link>
            <router-link to="/hbpos" class="dropdown-item"
              ><i class="bx bx-grid-alt font-size-16 align-middle me-1"></i>
              Thu hồi POS
            </router-link>
            <a href="/logout" class="dropdown-item text-danger"
              ><i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
              ></i>
              Đăng xuất
            </a>
          </b-dropdown>
        </div>
      </div>
    </header>
    <div :class="isLoading('main') ? 'flex-middle-full' : 'hidden'">
      <i class="fas fa-spinner fa-spin font-size-34"></i>
    </div>
    <div
      class="flex-middle-full"
      v-if="!isLoading('main') && !(sessionID > 0) && sessionList.length < 1"
    >
      Không có phiên bán hàng nào đang mở
    </div>
    <div
      class="flex-middle-full"
      v-if="!isLoading('main') && !(sessionID > 0) && sessionList.length > 1"
    >
      <div class="card">
        <div class="card-body">
          <h3>CHỌN PHIÊN BÁN HÀNG ĐỂ TIẾP TỤC</h3>
          <div
            class="btn-group-vertical"
            role="group"
            style="width: 100%"
            aria-label="Vertical radio toggle button group"
          >
            <div
              style="width: 100%; margin-bottom: 5px;"
              v-for="item in sessionList"
              :key="item.id"
            >
              <input
                type="radio"
                class="btn-check"
                @click="setSession(item)"
                :id="'vbtn-radio' + item.id"
              />
              <label
                style="width: 100%; margin-bottom: 10px;"
                class="btn btn-outline-info mb-0"
                :for="'vbtn-radio' + item.id"
                >{{ item.pos_name }} - {{ item.name }}</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="sale-layout"
      v-if="!isLoading('main') && sessionID > 0 && !currentTab.print"
    >
      <div class="card col-left">
        <list-product ref="listProduct"></list-product>
      </div>
      <div class="col-right">
        <div class="card">
          <div class="card-body p-0 mb-0 session-summary text-left">
            <div class="row-sale">
              <div class="col-left cursor-pointer" @click="showPopupCustomer">
                Khách hàng (F8):
              </div>
              <div class="col-right">{{ customerName }}</div>
            </div>
            <div class="row-sale border-top">
              <div class="col-left cursor-pointer" @click="showPopupCashier">
                Nhân viên bán hàng (F9):
              </div>
              <div class="col-right">{{ nvbh }}</div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body p-0 mb-0 session-summary text-left">
            <div class="row-sale">
              <div class="col-left">Tổng tiền hàng:</div>
              <div class="col-right">
                <span>{{ currentTab.info.subAmount | VND }} <sup>₫</sup></span>
              </div>
            </div>

            <div class="row-sale border-top">
              <div class="col-left cursor-pointer" @click="showPopupDiscount">
                Giảm khác (F6):
              </div>
              <div class="col-right">
                <span
                  >{{
                    (currentTab.info.otherDiscount > 0
                      ? "-" + currentTab.info.otherDiscount
                      : 0) | VND
                  }}
                  <sup>₫</sup></span
                >
              </div>
            </div>

            <div class="row-sale border-top">
              <div class="col-left cursor-pointer" @click="showPopupVoucher">
                Giảm voucher (F4):
              </div>
              <div class="col-right">
                <span
                  >{{
                    (currentTab.info.voucherDiscount > 0
                      ? "-" + currentTab.info.voucherDiscount
                      : 0) | VND
                  }}
                  <sup>₫</sup></span
                >
              </div>
            </div>

            <div class="row-sale border-top">
              <div class="col-left">
                Giảm thành viên
                <i v-if="currentTab.info.customerDiscount > 0"
                  >({{ currentTab.info.customerDiscount | VND }}%)</i
                >
                <i
                  v-if="currentTab.info.customerDiscount > 0"
                  @click="removeDiscountMember"
                  class="bx bx-x-circle btn-remove-discount-member"
                ></i
                >:
              </div>
              <div class="col-right">
                <span
                  >{{
                    (currentTab.info.customerDiscountValue > 0
                      ? "-" + currentTab.info.customerDiscountValue
                      : 0) | VND
                  }}
                  <sup>₫</sup></span
                >
              </div>
            </div>

            <div class="row-sale border-top">
              <div class="col-left">
                Tổng giảm:
              </div>
              <div class="col-right">
                <span
                  >{{
                    (currentTab.info.totalDiscount > 0
                      ? "-" + currentTab.info.totalDiscount
                      : 0) | VND
                  }}
                  <sup>₫</sup></span
                >
              </div>
            </div>

            <div class="row-sale border-top">
              <div
                class="col-left cursor-pointer"
                @click="showPopupTransportFee"
              >
                Phí vận chuyển:
              </div>
              <div class="col-right">
                <span
                  >{{
                    (currentTab.info.transportFee > 0
                      ? currentTab.info.transportFee
                      : 0) | VND
                  }}
                  <sup>₫</sup></span
                >
              </div>
            </div>

            <div
              class="row-sale border-top bold-text"
              style="font-size: 1.07em;"
            >
              <div class="col-left">Thành tiền:</div>
              <div class="col-right">
                <span
                  >{{ currentTab.info.totalAmount | VND }} <sup>₫</sup></span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body p-0 mb-0 session-summary text-left">
            <div class="row-sale border-top">
              <div class="col-left cursor-pointer" @click="showPopupEbill">
                Tổng giá trị eBill:
              </div>
              <div class="col-right">
                <span>{{ totalEbill | VND }} <sup>₫</sup></span>
              </div>
            </div>
            <div class="row-sale border-top">
              <div class="col-left cursor-pointer" @click="showPopupPayment">
                Khách thanh toán (F7):
              </div>
              <div class="col-right">
                <span>{{ totalPayment | VND }} <sup>₫</sup></span>
              </div>
            </div>
            <div class="row-sale border-top">
              <div class="col-left cursor-pointer">Tiền thừa trả khách:</div>
              <div class="col-right">
                <span>{{ returnAmount | VND }} <sup>₫</sup></span>
              </div>
            </div>
          </div>
        </div>

        <div class="card flex-end">
          <span class="icon-edit"><i class="bx bxs-pencil"></i></span>
          <textarea
            class="textarea-autosize"
            v-model="orderNote"
            id="input-note"
            placeholder="Nội dung ghi chú..."
            ref="inputNote"
            style="height: 100%"
          ></textarea>
        </div>

        <div class="card paid-box">
          <b-button variant="primary" @click="createOrder" class="btn-flat cursor-pointer" size="lg" ><i class="bx bx-money align-middle"></i> THANH TOÁN (F10)</b-button>
        </div>
      </div>
    </div>
    <print-cart
      v-if="!isLoading('main') && sessionID > 0 && currentTab.print"
    ></print-cart>
    <div id="noti-box">
      <b-alert
        v-for="item in noti"
        :key="item.id"
        show
        dismissible
        :variant="item.type"
      >
        <div
          style="font-weight: bold;"
          v-if="item.type == 'error' || item.type == 'danger'"
        >
          LỖI!
        </div>
        {{ item.text }}
      </b-alert>
    </div>
    <popup-voucher></popup-voucher>
    <popup-discount></popup-discount>
    <popup-customer></popup-customer>
    <popup-payment></popup-payment>
    <popup-cashier></popup-cashier>
    <popup-ebill></popup-ebill>
    <popup-select-discount></popup-select-discount>
    <popup-transport-fee></popup-transport-fee>
  </div>
</template>
